export const ADD_BUTTON_ICON_STYLE = {
    color: "green"
};

export const REMOVE_BUTTON_ICON_STYLE = {
    color: "red"
};